export default "__VITE_ASSET__BopS1Rwf__"